import { useEntity } from '@backstage/plugin-catalog-react';
import { isOwnerOf } from '@backstage/plugin-catalog-react/alpha';
import { getEntityRelations } from '@backstage/plugin-catalog-react';
import { RELATION_OWNED_BY } from '@backstage/catalog-model';

import { useEntities } from '../../util';
import { SlackCard } from './SlackCard';
import { slackLinks, uniqueSlackLinks } from './utils';

export const TeamSlackCard = () => {
  const { entity } = useEntity();

  const allChannels = useEntities(
    ['Component'],
    ['spec', 'metadata', 'relations'],
  )
    .filter(component => isOwnerOf(entity, component))
    .filter(
      component =>
        getEntityRelations(component, RELATION_OWNED_BY).length === 1,
    )
    .flatMap(component => slackLinks(component)); // If owned by various teams, skip it

  return <SlackCard links={uniqueSlackLinks(allChannels)} />;
};
